// @flow

import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { headerFragment } from 'common/fragments/www'

const headerQuery = gql`
query HeaderQuery {
  ${headerFragment}
}
`

export default (component: any) => graphql(headerQuery)(component)



// WEBPACK FOOTER //
// ./src/containers/pages/ReservationEditPage/graphql.js